import React, { useEffect, useState } from "react";
import Header from "./../components/Header";
import Rating from "../components/homeComponents/Rating";
import { Link } from "react-router-dom";
import Message from "./../components/LoadingError/Error";
import { useDispatch, useSelector } from "react-redux";
import {
  createProductReview,
  listProductDetails,
} from "../Redux/Actions/ProductActions";
import Loading from "../components/LoadingError/Loading";
import { PRODUCT_CREATE_REVIEW_RESET } from "../Redux/Constants/ProductConstants";
import moment from "moment";

const SingleProduct = ({ history, match }) => {
  window.scrollTo(0, 0);
  const [qty] = useState(1);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [selectedOption, setSelectedOption] = useState("framedPrint");

  const productId = match.params.id;
  const dispatch = useDispatch();

  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const productReviewCreate = useSelector((state) => state.productReviewCreate);
  const {
    loading: loadingCreateReview,
    error: errorCreateReview,
    success: successCreateReview,
  } = productReviewCreate;

  useEffect(() => {
    if (successCreateReview) {
      alert("Review Submitted");
      setRating(0);
      setComment("");
      dispatch({ type: PRODUCT_CREATE_REVIEW_RESET });
    }
    dispatch(listProductDetails(productId));
  }, [dispatch, productId, successCreateReview]);

  const AddToCartHandle = (e) => {
  e.preventDefault();
  history.push(`/cart/${productId}?qty=${qty}&option=${selectedOption}`);
};


  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      createProductReview(productId, {
        rating,
        comment,
      })
    );
  };

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  const displayPrice =
    selectedOption === "framedPrint" ? product.framedPrice : product.originalPrice;

  return (
    <>
      <Header className="product-header"/>
      <div className="full-width-bg">
        <div className="container single-product">
          {loading ? (
            <Loading />
          ) : error ? (
            <Message variant="alert-danger">{error}</Message>
          ) : (
            <div className="row">
              <div className="col-md-6">
                <div className="single-image">
                  <img src={product?.image} alt={product?.name} />
                </div>
              </div>
              <div className="col-md-6">
                <h2 className="product-name">{product?.name?.toUpperCase()}</h2>
                <h3 className="product-price">Ksh {displayPrice}</h3>
                <div className="product-options">
                {/* <div className="product-sizes">
                  <button className="size-btn">A1</button>
                  <button className="size-btn">A2</button>
                  <button className="size-btn">A3</button>
                  <button className="size-btn">A4</button>
                </div> */}
                  <button
                    className={`option-btn ${selectedOption === "framedPrint" ? "active" : ""}`}
                    onClick={() => handleOptionChange("framedPrint")}
                  >
                    Framed Print
                  </button>
                  <button
                    className={`option-btn ${selectedOption === "originalPainting" ? "active" : ""}`}
                    onClick={() => handleOptionChange("originalPainting")}
                  >
                    Original Painting
                  </button>
                </div>
                
                <button onClick={AddToCartHandle} className="add-to-cart-btn">
                  ADD TO CART
                </button>
                <div className="product-description">
                  <p>"{product?.description}"</p>
                </div>
              </div>
            </div>
          )}
          
            {/* RATING */}
            <div className="row my-5">
              <div className="col-md-6">
                <h6 className="mb-3 text-lg font-semibold">REVIEWS</h6>
                {product.reviews.length === 0 && (
                  <Message variant={"alert-info mt-3"}>No Reviews</Message>
                )}
                {product.reviews.map((review) => (
                  <div
                    key={review._id}
                    className="mb-5 mb-md-3 bg-white text-black shadow-md rounded p-4 border border-gray-200"
                  >
                    <strong className="text-blue-600">{review.name}</strong>
                    <Rating value={review.rating} />
                    <span className="text-black text-sm">
                      {moment(review.createdAt).calendar()}
                    </span>
                    <div className="alert alert-info mt-3 p-2 bg-blue-50 border border-blue-200 rounded">
                      {review.comment}
                    </div>
                  </div>
                ))}
              </div>
              <div className="col-md-6">
                <h6 className="text-lg font-semibold">WRITE A CUSTOMER REVIEW</h6>
                <div className="my-4">
                  {loadingCreateReview && <Loading />}
                  {errorCreateReview && (
                    <Message variant="alert-danger">
                      {errorCreateReview}
                    </Message>
                  )}
                </div>
                {userInfo ? (
                  <form onSubmit={submitHandler} className="bg-gray-100 p-4 rounded shadow-sm">
                    <div className="my-4">
                      <strong className="block">Rating</strong>
                      <select
                        value={rating}
                        onChange={(e) => setRating(e.target.value)}
                        className="col-12 bg-white p-3 mt-2 border border-gray-300 rounded"
                      >
                        <option value="">Select...</option>
                        <option value="1">1 - Poor</option>
                        <option value="2">2 - Fair</option>
                        <option value="3">3 - Good</option>
                        <option value="4">4 - Very Good</option>
                        <option value="5">5 - Excellent</option>
                      </select>
                    </div>
                    <div className="my-4">
                      <strong className="block">Comment</strong>
                      <textarea
                        rows="3"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        className="col-12 bg-white p-3 mt-2 border border-gray-300 rounded"
                      ></textarea>
                    </div>
                    <div className="my-3">
                      <button
                        disabled={loadingCreateReview}
                        className="col-12 bg-black border-0 p-3 rounded text-white hover:bg-gray-800 transition duration-200"
                      >
                        SUBMIT
                      </button>
                    </div>
                  </form>
                ) : (
                  <div className="my-3">
                    <Message variant={"alert-warning"}>
                      Please{" "}
                      <Link to="/login" className="font-semibold text-blue-600 hover:underline">
                        <strong>Login</strong>
                      </Link>{" "}
                      to write a review{" "}
                    </Message>
                  </div>
                )}
              </div>
            </div>
          
        </div>
      </div>
    </>
  );
};

export default SingleProduct;
